module.exports = __webpack_public_path__ + "img/home-world-best-banner-01.9b0151c9.jpg";